<template>
  <div class="core-input-field">
    <label
      :for="id"
      :class="['label-base', { 'label-error': hasError }]"
    >
      {{ label }}<span v-if="required" class="required-indicator"> *</span>
    </label>
    <input
      :id="id"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      class="input-base"
      :class="{ 'input-error': hasError }"
      @input="handleInput"
      @blur="handleBlur"
    />
    <span v-if="hasError" class="error-message">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  name: "InputField",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      internalError: ""
    };
  },
  computed: {
    hasError() {
      return Boolean(this.error) || Boolean(this.internalError);
    },
    errorMessage() {
      return this.error || this.internalError || "";
    }
  },
  watch: {
    value(newValue) {
      if (this.required) {
        const normalized = String(newValue == null ? "" : newValue).trim();
        if (normalized) {
          this.internalError = "";
        }
      }
    },
    error(newValue) {
      if (newValue) {
        this.internalError = "";
      }
    }
  },
  methods: {
    handleInput(event) {
      const currentValue = event.target ? event.target.value : "";
      this.$emit("input", currentValue);
      if (this.internalError) {
        this.internalError = "";
      }
    },
    handleBlur() {
      if (!this.required) {
        return;
      }

      const normalized = String(this.value == null ? "" : this.value).trim();
      if (!normalized) {
        const labelText = this.label ? this.label : "This field";
        this.internalError = labelText + " is required.";
      }
    }
  }
};
</script>

<style scoped>
.core-input-field {
  display: flex;
  flex-direction: column;
}

.label-base {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.label-error {
  color: #fa0202;
}

.required-indicator {
  color: #fa0202;
}

.input-base {
  width: 100%;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: 0.875rem;
  height: 36;
  transition: border-color 0.2s ease;
}

.input-base:focus {
  outline: none;
  border-color: #03a9f4;
}

.input-error {
  border-color: #fa0202;
  background-color: #fdecec;
}

.error-message {
  margin-top: 0.5rem;
  display: inline-block;
  border: 1px solid #fa0202;
  color: #fa0202;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  position: relative;
}

.error-message::before {
  content: "";
  position: absolute;
  top: -7px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ffffff;
  z-index: 1;
}

.error-message::after {
  content: "";
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fa0202;
  z-index: 0;
}
</style>
